import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { listAction } from "../../../network/store/action/UomResponseAction";
import axios from "axios";
import { API_CONFIG, API_HEADERS } from "../../../network/config/ApiConfig";
import { useLocation, useNavigate } from "react-router-dom";
import { consoleLog } from "../../../utils/log-utils";

function ProductPricing(){
  const dispatch = useDispatch();
  const [resultList, setResultList] = useState([]);
  const navigate=useNavigate()
  const location=useLocation();
  const productStoreId=location.state!=null?location.state.productStoreId:"";
  const productId=location.state!=null?location.state.productId:"";
  const priceId=location.state!=null?location.state.priceObj!=null?location.state.priceObj.id:"":"";
  const [pricingData,setPricingData]=useState({
    quantity:location.state!=null?location.state.priceObj!=null?location.state.priceObj.qty:"":"",
    uom:location.state!=null?location.state.priceObj!=null?location.state.priceObj.measure:"":"",
    purchasePrice:location.state!=null?location.state.priceObj!=null?location.state.priceObj.purchase_price:"":"",
    salePrice:location.state!=null?location.state.priceObj!=null?location.state.priceObj.price:"":"",
    offerPrice:location.state!=null?location.state.priceObj!=null?location.state.priceObj.offer:"":"",
    cgst:location.state!=null?location.state.priceObj!=null?location.state.priceObj.c_gst:"":"",
    sgst:location.state!=null?location.state.priceObj!=null?location.state.priceObj.s_gst:"":"",
    appPercentage:location.state!=null?location.state.priceObj!=null?location.state.priceObj.gsp_percentage:"":""
  })
  
  useEffect(()=>{
    consoleLog("price details",pricingData)
    loadData();
  },[])

  useEffect(()=>{
    consoleLog("priceId",priceId)
   
      if((pricingData.salePrice!=""&&pricingData.purchasePrice!="")||pricingData.offerPrice!=""){
        setPricingData({
            ...pricingData,
            appPercentage:Math.round(((+pricingData.salePrice)-(+pricingData.purchasePrice))/(+pricingData.salePrice)*100)-(+pricingData.offerPrice)
        })
    }
    
    
   },[pricingData.offerPrice,pricingData.salePrice,pricingData.purchasePrice])

  const loadData = async () => {
      await dispatch(listAction(dispatch)).then((reponse) => {
        if (reponse.result) {
          setResultList(reponse.result);
        }
      });
    };

    const onHandleChange=(e)=>{
        setPricingData({
          ...pricingData,
          [e.target.name]:e.target.value
        })
    }

    const onSubmit=async()=>{
      // @JsonKey(name: "storeId")
  // @JsonKey(name: "gsp_percentage")
  // @JsonKey(name: "productId")
  // @JsonKey(name: "id")
  // @JsonKey(name: "qty")
  // @JsonKey(name: "measure")
  // @JsonKey(name: "quantity")
  // @JsonKey(name: "price")
  // @JsonKey(name: "offer")
  // @JsonKey(name: "s_gst")
  // @JsonKey(name: "c_gst")
  // @JsonKey(name: "purchase_price")
let requestBody=null;
if(priceId!==""){
  requestBody={
    storeId:productStoreId,
    productId:productId,
    s_gst:pricingData.sgst,
    c_gst:pricingData.cgst,
    price:pricingData.salePrice,
    offer:pricingData.offerPrice,
    purchase_price:pricingData.purchasePrice,
    gsp_percentage:pricingData.appPercentage,
    qty:pricingData.quantity,
    measure:pricingData.uom,
    id:priceId,
    quantity:pricingData.quantity+pricingData.uom
}
}
else{
      requestBody={
          storeId:productStoreId,
          productId:productId,
          s_gst:pricingData.sgst,
          c_gst:pricingData.cgst,
          price:pricingData.salePrice,
          offer:pricingData.offerPrice,
          purchase_price:pricingData.purchasePrice,
          gsp_percentage:pricingData.appPercentage,
          qty:pricingData.quantity,
          measure:pricingData.uom,
          quantity:pricingData.quantity+pricingData.uom
      }
    }
      let data=await axios.post(API_CONFIG.API_HOST+"ProductPrice/update",requestBody,{
        headers:API_HEADERS
      })
      console.log("updated price",data)
      data.status===200&&navigate(-1)
      
    }

    return(
        <>
        <div
        style={{
          position: "fixed",
          alignContent:"center",
          backgroundColor: "rgba(0,0,0,0.5)",
          width: "100%",
          height: "100%",
          zIndex: "999",
          overflow: "scroll",
        }}
      >
        
        <div className="d-flex align-item-center justify-content-center w-75">
           <div className="card-1 p-5">
              <div className="d-flex flex-row">
                <div>
                <label>Quantity</label>
                <input type="text" placeholder="Quantity" className="form-control" name="quantity" value={pricingData.quantity} onChange={onHandleChange} />
                </div>
                <div>
                <label>UOM</label>
                <select className="form-control" style={{borderStyle:"none"}} name="uom" value={pricingData.uom} onChange={onHandleChange}>
                  <option value={""}>
                    {"--select UOM--"}
                  </option>
                  {
                    resultList.length>0 && resultList.map((item,i)=>{
                      return(
                        <option value={item.name} key={i}>{item.name}</option>
                      )
                    })
                  }
                </select>
                </div>
              </div>
           
           <label>Purchase Price</label>
           <input type="number" placeholder="Purchase Price" className="form-control" name="purchasePrice" value={pricingData.purchasePrice} onChange={onHandleChange} />
           <label>Price</label>
           <input type="number" placeholder="Price" className="form-control" name="salePrice" value={pricingData.salePrice} onChange={onHandleChange} />
          <label className="w-100">{(pricingData.salePrice!=""&& pricingData.purchasePrice!=="")?Math.round(((+pricingData.salePrice)-(+pricingData.purchasePrice))/(+pricingData.salePrice)*100):""}%on Purchase</label>
           <label>Offer %</label>
           <input type="number" placeholder="offer (%)" className="form-control" name="offerPrice" value={pricingData.offerPrice} onChange={onHandleChange}/>
           <label className="w-100">App Sale Price</label>
           <label>CGST</label>
           <input type="number" placeholder="CGST" className="form-control" name="cgst" value={pricingData.cgst} onChange={onHandleChange} />
           <label>SGST</label>
           <input type="number" placeholder="SGST" className="form-control" name="sgst" value={pricingData.sgst} onChange={onHandleChange} />
           <label>APP %</label>
           <input type="number" placeholder="App %" className="form-control" name="appPercentage" value={pricingData.appPercentage} onChange={onHandleChange} />
           <div className="d-flex flex-row justify-content-center mt-2">
            <button className="btn btn-success" onClick={onSubmit}>Submit</button>
           </div>
        </div>
        </div>
      </div>
        </>
    )

}
export default ProductPricing